var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "registration" },
    [
      _c("vue-title", {
        attrs: { title: _vm.$t("identityProvider:login:verifyOTPTitle") }
      }),
      _vm._v(" "),
      _vm.model.showError
        ? _c("div", [
            _c("h1", { staticClass: "section-title" }, [
              _vm._v(_vm._s(_vm.$t("identityProvider:login:verifyOTPTitle")))
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "validation-summary-errors alert alert-danger fade show",
                attrs: {
                  role: "alert",
                  "data-valmsg-summary": "true",
                  "data-test-element": "idp-alert-danger-generic"
                }
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("warning")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.model.errorMessage))])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button",
                attrs: {
                  type: "button",
                  name: "Action:RedirectToLogin",
                  disabled: _vm.disabled
                },
                on: {
                  click: function($event) {
                    return _vm.loginCancel(_vm.logoutLink)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("shared:action:back")))]
            )
          ])
        : _c("div", [
            _c(
              "form",
              {
                ref: "form",
                attrs: { action: "authentication/submitverificationcode" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.validateBeforeSubmit.apply(null, arguments)
                  }
                }
              },
              [
                _c("h1", { staticClass: "section-title" }, [
                  _vm._v(
                    _vm._s(_vm.$t("identityProvider:login:verifyOTPTitle"))
                  )
                ]),
                _vm._v(" "),
                _c("fieldset", [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.model.showError &&
                            _vm.model.errorMessage != null,
                          expression:
                            "!model.showError && model.errorMessage!=null"
                        }
                      ],
                      class: _vm.alertContent,
                      attrs: {
                        role: "alert",
                        "data-valmsg-summary": "true",
                        "data-test-element": "idp-alert-danger-generic"
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "material-icons",
                        domProps: { innerHTML: _vm._s(_vm.messageIcon) }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "pad-2" }, [
                        _vm._v(_vm._s(_vm.model.errorMessage))
                      ]),
                      _vm._v(" "),
                      _c(
                        "i",
                        {
                          staticClass: "material-icons ml-auto pointer",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.closeBanner.apply(null, arguments)
                            }
                          }
                        },
                        [_vm._v("close")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "panel-message" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.otpinstructionModel.instructions) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group w-50" }, [
                    _c("label", [
                      _c("span", { staticClass: "item label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("identityProvider:login:verifyOTPCodeHeader")
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.verificationCode,
                          expression: "model.verificationCode"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: {
                            required: true,
                            regex: _vm.complexityOtpModel.otpPattern,
                            min: _vm.complexityOtpModel.otpMinimumLength,
                            max: _vm.complexityOtpModel.otpMaximumLength
                          },
                          expression:
                            "{ required: true, regex: complexityOtpModel.otpPattern, min: complexityOtpModel.otpMinimumLength, max: complexityOtpModel.otpMaximumLength }"
                        }
                      ],
                      staticClass: "w-100 mb-2 input-text control",
                      class: {
                        "input-validation-error": _vm.hasErrorOn("verifyCode")
                      },
                      attrs: {
                        type: "text",
                        id: "txtverificationcode",
                        maxlength: _vm.complexityOtpModel.otpMaximumLength,
                        name: "verifyCode",
                        autocomplete: "off"
                      },
                      domProps: { value: _vm.model.verificationCode },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.model,
                            "verificationCode",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.hasErrorOn("verifyCode"),
                            expression: "hasErrorOn('verifyCode')"
                          }
                        ],
                        staticClass: "field-validation-error"
                      },
                      [_vm._v(_vm._s(_vm.errors.first("verifyCode")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                          }
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "link",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.isLinkEnabled
                                  ? _vm.resendVerificationCode(_vm.resendLink)
                                  : "return false;"
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "identityProvider:login:verifyOTPSendAnotherCode"
                                )
                              )
                            )
                          ]
                        ),
                        _c(
                          "contextual-help-component",
                          {
                            directives: [
                              {
                                name: "click-outside-tooltip",
                                rawName: "v-click-outside-tooltip",
                                value: _vm.hideToolTip,
                                expression: "hideToolTip"
                              }
                            ],
                            attrs: {
                              text: _vm.$t(
                                "identityProvider:login:tooltipSendAnotherCode"
                              ),
                              "data-test-element": "sendanothercode-help"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "identityProvider:login:tooltipSendAnotherCode"
                                )
                              )
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-actions mb-3" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button",
                        attrs: { type: "submit", disabled: _vm.disabled }
                      },
                      [_vm._v(_vm._s(_vm.$t("shared:action:continue")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "button-secondary contextual-link",
                        attrs: {
                          "data-test-element": "security-question-cancel"
                        },
                        on: {
                          click: function($event) {
                            return _vm.loginCancel(_vm.cancelLink)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("shared:action:cancel")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "panel-message" }, [
                    _c(
                      "span",
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "identityProvider:login:verifyOTPNewPhoneNumber"
                              )
                            ) +
                            "\n            "
                        ),
                        _c(
                          "router-link",
                          { attrs: { to: _vm.previousPageUrl } },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "link link-text-transform",
                                on: { click: _vm.hideToolTip }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "identityProvider:login:verifyOTPClickHere"
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ])
              ]
            )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-403d261a", { render: render, staticRenderFns: staticRenderFns })
  }
}